module.exports = __webpack_public_path__ + "../resources/img/2022_qcells_new_logo.1c7663a1.png";